<template>
  <el-dialog
    :append-to-body="true"
    :visible.sync="roleForm.show"
    :mask-closable="false"
    @cancelclick="toggle(false)"
    title="给某人配置角色">
    <div class="member-bd checkbox-group-block">
      <el-checkbox-group v-model="chosenList">
        <el-checkbox v-for="(item, index) of roleForm.list"
                     :label="item.RoleId"
                     :key="index">
          <el-tooltip :content="item.RoleName" placement="bottom" effect="dark">
            <span class="el-checkbox-ellipsis">{{ item.RoleName }}</span>
          </el-tooltip>
        </el-checkbox>
      </el-checkbox-group>
    </div>
    <div slot="footer">
      <el-button type="default" @click="toggle(false)">取消</el-button>
      <el-button type="primary" @click="onSubmit">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import sortedUniq from 'lodash/sortedUniq';
  import { deepCopy } from '../../core/utils/helper';

  export default {
    name: 'add-role',

    model: {
      prop: 'roleForm',
      event: 'change',
    },

    props: {
      roleForm: {
        type: Object,
        default () {
          return {};
        },
      },
    },

    data () {
      return {
        chosenList: [],
      };
    },

    watch: {
      'roleForm.show' (val) {
        if (val) {
          if (this.roleForm.memberInfo &&
            this.roleForm.memberInfo.accrole &&
            this.roleForm.memberInfo.accrole.RoleIds) {
            let roleIds = this.roleForm.memberInfo.accrole.RoleIds.split(',');
            // 把用户已有角色显示出来，备用
            this.$set(this, 'chosenList', roleIds);
          }
          else {
            this.$set(this, 'chosenList', []);
          }
        }
      },
    },

    methods: {
      toggle (show, row) {
        this.$emit('toggle-role-modal', show, row);
      },
      onSubmit () {
        let RoleIds = this.roleForm.memberInfo.accrole.RoleIds;
        let Uid = this.roleForm.memberInfo.accrole.Uid;
        // 如果选中的角色为空，而且该用户之前也没配置过角色，则不允许点击确认
        if (!this.chosenList.length && !RoleIds) {
          this.$toast.error('请先选择某个角色再点击确认');
          return;
        }
        this.$emit('add-member-role', {
          Uid,
          // 去重
          RoleIds: sortedUniq(deepCopy(this.chosenList)),
        });
      },
    },
  };
</script>
<style lang="less" src="./styles/index.less"></style>